module.exports = "/global_cta_new-c492e13b2cc0560fdea3c5b2fe0b3b58.png";